import { attr, fk } from 'redux-orm';

import BaseModel from './BaseModel';
import ActionTypes from '../constants/ActionTypes';

export default class extends BaseModel {
  static modelName = 'DampingCoefficient';

  static fields = {
    id: attr(),
    from: attr(),
    to: attr(),
    value: attr(),
    pointSistemId: fk({
      to: 'PointSystem',
      as: 'pointSystem',
      relatedName: 'dampingCoefficients',
    }),
  };

  static reducer({ type, payload }, DampingCoefficient) {
    switch (type) {
      case ActionTypes.SOCKET_RECONNECT_HANDLE:
        DampingCoefficient.all().delete();

        if (payload.dampingCoefficients) {
          payload.dampingCoefficients.forEach((dampingCoefficient) => {
            DampingCoefficient.upsert(dampingCoefficient);
          });
        }

        break;
      case ActionTypes.CORE_INITIALIZE:
        if (payload.dampingCoefficients) {
          payload.dampingCoefficients.forEach((dampingCoefficient) => {
            DampingCoefficient.upsert(dampingCoefficient);
          });
        }

        break;
      case ActionTypes.DAMPING_COEFFICIENT_GET_OR_CREATE__SUCCESS:
      case ActionTypes.DAMPING_COEFFICIENT_CREATE__SUCCESS:
      case ActionTypes.DAMPING_COEFFICIENT_UPDATE__SUCCESS:
        DampingCoefficient.upsert(payload.item);

        break;
      case ActionTypes.DAMPING_COEFFICIENTS_FETCH__SUCCESS: {
        console.log('[DampingCoefficient reducer] DAMPING_COEFFICIENTS_FETCH__SUCCESS, pointSystemId:', payload.pointSystemId, 'items:', payload.items);
        console.log('[DampingCoefficient reducer] Количество items:', payload.items?.length || 0);
        
        // Проверяем структуру первого элемента, если есть
        if (payload.items && payload.items.length > 0) {
          console.log('[DampingCoefficient reducer] Первый item структура:', payload.items[0]);
          console.log('[DampingCoefficient reducer] Первый item поля:', Object.keys(payload.items[0]));
          console.log('[DampingCoefficient reducer] Первый item pointSystemId:', payload.items[0].pointSystemId);
          console.log('[DampingCoefficient reducer] Первый item pointSistemId:', payload.items[0].pointSistemId);
        }
        
        // Удаляем старые записи для данного pointSystemId
        const beforeDelete = DampingCoefficient.all().filter({ pointSistemId: payload.pointSystemId }).toRefArray();
        console.log('[DampingCoefficient reducer] Записей до удаления:', beforeDelete.length);
        DampingCoefficient.filter({ pointSistemId: payload.pointSystemId }).delete();
        
        // Преобразуем данные, если приходят с полем pointSystemId вместо pointSistemId
        const itemsToUpsert = payload.items?.map((item) => {
          // Если приходит pointSystemId, преобразуем в pointSistemId
          if (item.pointSystemId && !item.pointSistemId) {
            return {
              ...item,
              pointSistemId: item.pointSystemId,
            };
          }
          return item;
        }) || [];
        
        console.log('[DampingCoefficient reducer] Items для upsert:', itemsToUpsert);
        
        // Сохраняем данные
        itemsToUpsert.forEach((item) => {
          console.log('[DampingCoefficient reducer] Upsert item:', item);
          DampingCoefficient.upsert(item);
        });
        
        // Проверяем, что данные сохранились
        const afterUpsert = DampingCoefficient.all().filter({ pointSistemId: payload.pointSystemId }).toRefArray();
        console.log('[DampingCoefficient reducer] После upsert в ORM, количество:', afterUpsert.length);
        console.log('[DampingCoefficient reducer] После upsert в ORM, данные:', afterUpsert);
        
        // Также проверяем все DampingCoefficients
        const allDampingCoefficients = DampingCoefficient.all().toRefArray();
        console.log('[DampingCoefficient reducer] Всего DampingCoefficients в ORM:', allDampingCoefficients.length);
        if (allDampingCoefficients.length > 0) {
          console.log('[DampingCoefficient reducer] Первый DampingCoefficient:', allDampingCoefficients[0]);
        }

        break;
      }
      case ActionTypes.DAMPING_COEFFICIENT_DELETE__SUCCESS:
        DampingCoefficient.withId(payload.item.id)?.delete();

        break;
      default:
    }
  }
}

